import LeaveRequestEvidenceController from './LeaveRequestEvidenceController';

export default LeaveRequestEvidenceController;
